export default "__VITE_ASSET__CfTO09wz__"